// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"styles_callToAction__0lHox","icon":"styles_icon__HXwYN","label":"styles_label__tY9u7"};